import React from 'react';
import styles from './Mobile.module.css';

interface MobileHeaderProps {
    userName: string;
    onLogout: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ userName, onLogout }) => {
    return (
        <div className={styles.mobileHeader}>
            <img
                src="/assets/img/rafiki_blue.svg"
                alt="Rafiki"
                className={styles.headerLogo}
            />
            <span className={styles.headerUser}>{userName}</span>
            <button className={styles.logoutButton} onClick={onLogout}>
                Logout
            </button>
        </div>
    );
};

export default MobileHeader;
